import {Capacitor} from "@capacitor/core";

declare const google: any;

export const getPlacePredictions: any = (service, input) => new Promise((resolve, reject) => {
  if (!input) {
    return resolve([]);
  }
  return service.getPlacePredictions({
    input,
    componentRestrictions: {country: 'DE'},
    location: new google.maps.LatLng(50.28362, 8.27888), // TODO: extract to config, as well as gmaps api key
    radius: 15 * 1000,
    types: ['geocode']
  }, function async(predictions, status) {
    if (!predictions) {
      return;
    }


    resolve(predictions);
  });
});

const {Storage} = Capacitor.Plugins;
export const getConfig = async () => {
  const result = await Storage.get({ key: "customer" });
  const data = JSON.parse(result.value);
  return data;
};

export const distance = (lat1, lon1, lat2, lon2) => {
  if ((lat1 == lat2) && (lon1 == lon2)) {
    return 0;
  } else {
    var radlat1 = Math.PI * lat1 / 180;
    var radlat2 = Math.PI * lat2 / 180;
    var theta = lon1 - lon2;
    var radtheta = Math.PI * theta / 180;
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
      dist = 1;
    }
    dist = Math.acos(dist);
    dist = dist * 180 / Math.PI;
    dist = dist * 60 * 1.1515;
    dist = dist * 1.609344;
    return dist;
  }
}

export const get: any = (storage: any, key: string) => {
  return new Promise((resolve, reject) => {
    storage.get(key).then((result => {
      console.log(result);
      resolve(result);
    }));
  });
}



// WEBPACK FOOTER //
// ./src/app/utils.ts